document.addEventListener('alpine:init', () => {
  Alpine.store('xUpsellPopup', {
    isOpen: false,
    activeTab: 0,
    addons: {},
    basePrice: 0,
    baseQty: 1,

    open(price, qty = 1) {
      this.activeTab = 0;
      this.addons = {};
      this.basePrice = typeof price === 'number' ? price : (parseInt(price) || 0);
      this.baseQty = parseInt(qty) || 1;
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.isOpen = false;
      document.body.style.overflow = '';
    },

    switchTab(index) {
      this.activeTab = index;
    },

    toggle(variantId, price) {
      const id = String(variantId);
      if (this.addons[id] && this.addons[id].qty > 0) {
        this.addons[id].qty = 0;
      } else {
        this.addons[id] = { qty: 1, price: parseInt(price) || 0 };
      }
      this.addons = { ...this.addons };
    },

    increment(variantId, price, qty = 1) {
      const id = String(variantId);
      if (!this.addons[id]) {
        this.addons[id] = { qty: 0, price: parseInt(price) || 0 };
      }
      this.addons[id].qty += qty;
      this.addons = { ...this.addons };
    },

    decrement(variantId) {
      const id = String(variantId);
      if (this.addons[id] && this.addons[id].qty > 0) {
        this.addons[id].qty--;
        this.addons = { ...this.addons };
      }
    },

    removeVariant(variantId) {
      const id = String(variantId);
      if (this.addons[id]) {
        delete this.addons[id];
        this.addons = { ...this.addons };
      }
    },

    getQty(variantId) {
      return (this.addons[String(variantId)] || { qty: 0 }).qty;
    },

    addonsCount() {
      return Object.values(this.addons).reduce((s, a) => s + a.qty, 0);
    },

    addonsTotal() {
      return Object.values(this.addons).reduce((s, a) => s + a.qty * a.price, 0);
    },

    total() {
      return this.basePrice * this.baseQty + this.addonsTotal();
    },

    formatMoney(cents) {
      if (typeof cents !== 'number') cents = parseInt(cents) || 0;

      function fmt(n, precision, thousands, decimal) {
        const fixed = (n / 100).toFixed(precision);
        const parts = fixed.split('.');
        const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return precision > 0 ? whole + decimal + parts[1] : whole;
      }

      const moneyFormat = (window.Eurus && window.Eurus.moneyFormat) || '{{amount}}';
      const map = {
        '{{amount}}':                                     fmt(cents, 2, ',', '.'),
        '{{amount_no_decimals}}':                         fmt(cents, 0, ',', '.'),
        '{{amount_with_comma_separator}}':                fmt(cents, 2, '.', ','),
        '{{amount_no_decimals_with_comma_separator}}':    fmt(cents, 0, '.', ','),
        '{{amount_with_apostrophe_separator}}':           fmt(cents, 2, "'", '.'),
        '{{amount_with_space_separator}}':                fmt(cents, 2, ' ', '.'),
        '{{amount_no_decimals_with_space_separator}}':    fmt(cents, 0, ' ', '.'),
      };

      let result = moneyFormat;
      for (const [token, value] of Object.entries(map)) {
        result = result.replace(token, value);
      }
      return result;
    },

    async goToCart() {
      const items = Object.entries(this.addons)
        .filter(([, v]) => v.qty > 0)
        .map(([id, v]) => ({ id: parseInt(id), quantity: v.qty }));
      
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (items.length > 0) {
        try {
          await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
        } catch (e) {
          console.error('[UpsellPopup] add to cart error:', e);
        }
      }
      window.location.href = root + 'cart';
    },
  });
});
